'use strict';
// TODO: Remove this module from `core-js@4` since it's replaced to module below
require('../modules/es.map.constructor');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es.map.js
// module id = 571
// module chunks = 0